module.exports = __webpack_public_path__ + "img/cn.a94c9394.svg";